import * as React from 'react';
export const CXSvg = React.forwardRef(function CXSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M2 14h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M14.245 3.155a3 3 0 0 1-3.892 4.428h.047c2.154 0 3.9-1.697 3.9-3.791 0-.217-.019-.43-.055-.637ZM6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#217AB7',
        d: 'M14 14c.51 0 .975-.19 1.328-.504L.673 2.504C.26 2.871 0 3.404 0 4v8a2 2 0 0 0 2 2h12Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M1.5 10a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1 3a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1-2a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1-3a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Z',
      }),
    ),
  );
});
CXSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var CX = {
  category: 'flag',
  colorable: false,
  name: 'CX',
  svg: CXSvg,
};
